import React, { useMemo } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { fieldSxFromTheme, getGabbaiTheme } from './gabbaiPortalTheme';

function filterByLabel(options, state) {
  const q = state.inputValue.trim().toLowerCase();
  if (!q) return options;
  return options.filter((o) => String(o.label || '').toLowerCase().includes(q));
}

/**
 * בחירה מרשימה עם חיפוש בהקלדה — לפורטל גבאים.
 * options: [{ id, label }]
 * value: id (string) או ''
 * onChange(id)
 */
export default function PortalSearchSelect({
  label,
  options = [],
  value = '',
  onChange,
  placeholder = 'חיפוש...',
  disabled = false,
  sx = {},
  noOptionsText = 'לא נמצאו תוצאות',
}) {
  const t = getGabbaiTheme();
  const fieldSx = fieldSxFromTheme(t);

  const selected = useMemo(
    () => options.find((o) => String(o.id) === String(value)) || null,
    [options, value]
  );

  const autocompleteSx = {
    ...fieldSx,
    '& .MuiAutocomplete-popupIndicator': { color: t.accentSoft },
    '& .MuiAutocomplete-clearIndicator': { color: 'rgba(245,240,230,0.6)' },
    ...sx,
  };

  const listSx = {
    bgcolor: t.listBg,
    color: '#f5f0e6',
    '& .MuiAutocomplete-option': {
      '&[aria-selected="true"]': {
        bgcolor: t.accentMuted.replace('0.35', '0.2').replace('0.38', '0.2'),
      },
      '&.Mui-focused': {
        bgcolor: t.accentMuted.replace('0.35', '0.12').replace('0.38', '0.12'),
      },
    },
  };

  return (
    <Autocomplete
      options={options}
      value={selected}
      onChange={(_, opt) => onChange?.(opt ? String(opt.id) : '')}
      getOptionLabel={(opt) => opt?.label || ''}
      isOptionEqualToValue={(opt, val) => String(opt?.id) === String(val?.id)}
      filterOptions={filterByLabel}
      disabled={disabled}
      clearOnEscape
      noOptionsText={noOptionsText}
      sx={autocompleteSx}
      ListboxProps={{ sx: listSx }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          sx={fieldSx}
        />
      )}
    />
  );
}
